import React, { useState, useEffect } from 'react'
import FilterPage, { generateInitialValue } from '../fragments/filter-page'
import {
	action_fetch_category,
	action_add_category_list,
	action_fetch_category_list,
	action_fetch_category_sorters,
	action_fetch_category_filter,
	action_fetch_category_parent_nodes,
	__Default_Category_Limit_For_DeskTop__
} from '../../../../../store/actions/pages/category'

import {
	action_fetch_list_top_banner
} from '../../../../../store/actions/global'

import { filterItemsToString, getFilterItemsFromQuery, getTopBanner, getPageUrl } from '../../../../pages/listing/utils'
import { useDispatch, useSelector } from 'react-redux'
import ListingProducts, { PageListProducts } from '../components/list'
import { getCategoryUrl } from '../../../../../utils/url'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useQuery } from '../../../../hooks/common'
import { FormattedMessage } from 'react-intl'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Empty from '../fragments/empty-page'
import BlockImage from '../../../components/image/block-image'
import { useSensors } from '../../../../hooks/sensor'
import { generateFilter } from '../../../../utils/sensor'
import TwitterEvents from '../../../../ads/events/twitter'
import BottomBannerTip from '../../../layout/fragments/bottom-banner'
import { PinterestAlert } from '../../../layout/fragments/alert-popup'


const getValidFilterItems = items => {
	const newItems = []

	items?.forEach(item => {
		if (['color', 'size', 'tags', 'category', 'category_ids'].indexOf(item.fieldName) >= 0 || item.fieldName?.indexOf('tags-') === 0) {
			newItems.push(item)
		}
	})
	return newItems
}

const parseParams = search => {
	if (!search) return
	let newParams = {}
	Object.keys(search).forEach(key => {
		if (search[key] instanceof Array) {
			newParams[key] = search[key]?.filter((value, index, s) => s.indexOf(value) === index).join?.(',')
		} else {
			newParams[key] = search[key]
		}
	})

	if (search?.sort_by) {
		newParams['parentSkus'] = search.sort_by
	}

	if (search?.recommend_data_source) {
		newParams['recommendDataSource'] = search.recommend_data_source
	}
	return newParams
}


const Category = props => {
	useStyles(classes)
	const dispatch = useDispatch()
	const history = useHistory()
	const location = useLocation()
	const params = useParams()
	const pageCategory = useSelector((state) => state.pageCategory)
	const global = useSelector(state => state.global)
	const { listTopBanner } = global
	const category = pageCategory?.category || { id: params?.id }
	// const banner = listTopBanner?.[category?.id] || listTopBanner?.['__Default_Banner__']
	const banner = getTopBanner(listTopBanner, category?.id)
	const sorters = pageCategory?.sorters
	const query = useQuery()
	const [originQuery, setOriginQuery] = useState(query)
	const baseUrl = getCategoryUrl(category?.id, category?.name)

	const [data, setData] = useState({
		categoryId: category?.id,
		sorter: (sorters instanceof Array) ? sorters?.[query.sort || 0]?.value : query.sort,
		startPrice: Number(query?.lowerPrice) || undefined,
		endPrice: Number(query?.higherPrice) || undefined,
		filterItems: generateInitialValue(query, pageCategory?.filterVo?.filterItems)
	})

	const sort = isNaN(data?.sorter) && (sorters instanceof Array) ? sorters?.findIndex(s => s.value === data?.sorter) : data?.sorter

	const [showPinterestAlert, setShowPinterestAlert] = useState(false)

	const filterHandle = (filterItems, sort, price) => {
		const filter = {
			categoryId: pageCategory?.category?.id,
			sorter: (sorters instanceof Array) ? sorters?.[sort || 0]?.value : sort,
			startPrice: price?.minPrice || undefined,
			endPrice: price?.maxPrice || undefined,
			filterItems: filterItems?.filter?.(item => item?.selections?.length > 0)
		}
		setData(filter)
		dispatch(action_fetch_category_list(filter, { limit: __Default_Category_Limit_For_DeskTop__, recommendDataSource: originQuery?.recommend_data_source }, {}))
		const url = `${baseUrl}?${filterItemsToString(filterItems, sort, price)}`
		history.replace(url)
	}

	const onScroll = () => {
		dispatch(action_add_category_list(data, { ...query, parentSkus: query?.sort_by, skip: pageCategory?.skip, limit: __Default_Category_Limit_For_DeskTop__, recommendDataSource: originQuery?.recommend_data_source }, {}))
	}

	const onPage = page => {
		window.location.href = getPageUrl(window.location.href, page)
	}

	useEffect(() => {
		if(query?.utm_source){
			setShowPinterestAlert(true)
		}
		TwitterEvents.viewList({ products: pageCategory?.list })
	}, [])

	const [sensors, setSensors] = useState(useSensors())
	const filterStr = generateFilter(pageCategory?.filterData, pageCategory?.sorters)

	const basePageUrl = `${location.pathname}${location.search}`

	const List = pageCategory?.total > 0 ? PageListProducts : ListingProducts

	const parentLinks = pageCategory?.parentNodes?.slice(0, pageCategory?.parentNodes?.length - 1)?.map(pn => ({
		href: getCategoryUrl(pn.id, pn.name),
		title: <span>
			<span>{pn.name}</span>
		</span>
	}))

	return <React.Fragment>
		<FilterPage
			links={[
				...parentLinks||[],
				{
					href: '#',
					title: <span>
						<span>{category?.name}</span>
						{
							pageCategory?.total > 0 && <span className={classes.Total}>
								(<FormattedMessage id="count_items" values={{ total: pageCategory?.total }} defaultMessage="{total} Items" />)
							</span>
						}
					</span>,
					keywords: [],
				}
			]}
			extra={() => {
				return <>
					{
						banner && banner.src && <div style={{ marginTop: 20 }}>
							<BlockImage sensors={{
								position: 1,
								content: banner.refId,
								type: '1',
								title: 'list'
							}} href={banner.href} title={banner.title} src={banner.src} width={banner.width} height={banner.height} />
						</div>
					}
				</>
			}}
			baseUrl={baseUrl}
			title={category?.name}
			filterVO={pageCategory?.filterVo}
			sorters={pageCategory?.sorters}

			value={data?.filterItems}
			sort={sort}
			minPrice={data?.startPrice}
			maxPrice={data?.endPrice}
			showFooter={pageCategory?.total > 0}
			onFilter={filterHandle}>
			{
				pageCategory?.finished && (!pageCategory?.list || pageCategory?.list?.length < 1) ? <Empty /> : <List
					pagination={{
						total: pageCategory?.total,
						pageSize: __Default_Category_Limit_For_DeskTop__,
						currentPage: Number(query?.page) || 1,
						onPage: onPage,
						baseUrl: basePageUrl,
					}}
					filter={filterStr} sensors={sensors} products={pageCategory?.list} request={onScroll} loading={pageCategory?.loading} finished={pageCategory?.finished} />
			}

			<BottomBannerTip />
		</FilterPage>

		{ showPinterestAlert && <PinterestAlert/> }

	</React.Fragment>
}


Category.fetchData = async (store, params, search, headers) => {

	const initialFilterItems = getFilterItemsFromQuery(search)
	const sort = search.sort || 0
	const sorters = await store.dispatch(action_fetch_category_sorters({}, headers))
	const sorter = (sorters instanceof Array) ? sorters?.[sort]?.value : sort
	const categoryId = params.id || search?.categoryId
	const page = Number(search?.page) || 1

	const filter = {
		categoryId,
		sorter: sorter,
		startPrice: Number(search?.lowerPrice) || undefined,
		endPrice: Number(search?.higherPrice) || undefined,
		filterItems: getValidFilterItems(initialFilterItems),
	}

	const parsedParams = parseParams(search) || {}

	parsedParams.limit = __Default_Category_Limit_For_DeskTop__
	parsedParams.skip = (page - 1) * __Default_Category_Limit_For_DeskTop__

	const values = await Promise.all([
		store.dispatch(action_fetch_category(categoryId, headers)),
		store.dispatch(action_fetch_category_list(filter, parsedParams, headers)),
		store.dispatch(action_fetch_category_filter({ categoryId }, headers)),
		store.dispatch(action_fetch_list_top_banner(headers)),
		store.dispatch(action_fetch_category_parent_nodes(categoryId, headers))
	])
	return [...values, sorters]
}

export default Category